<template>
  <div class="sms_template_list_add">
    <el-card>
      <el-page-header @back="goBack" style="margin-bottom: 20px;"></el-page-header>
      <div class="flex">
        <el-form :model="form" label-width="120px" style="flex:1">
          <el-form-item label="短信模板标题">
            <el-col :span="8">
              <fuzzy-selection
                  tipName="短信模板"
                  @upSmsDetail="getTemplateById"
                  :type="12"
                  width="100%"
                  :value.sync="form.templateId"
              ></fuzzy-selection>
            </el-col>
          </el-form-item>
          <el-form-item label="任务标题">
            <el-col :span="8">
              <el-input placeholder="请输入标题" v-model="form.title"></el-input>
            </el-col>
          </el-form-item>
          <el-form-item label="签名">
            <el-col :span="8">
              <el-input placeholder="请输入签名" disabled v-model="form.sign"></el-input>
            </el-col>
          </el-form-item>

          <el-form-item label="模板内容">
            <div>
              <el-col :span="12">
                <el-input
                    disabled
                    placeholder="请输入模板内容"
                    :rows="8"
                    type="textarea"
                    v-model="templateDetail.content"
                    show-word-limit
                    maxlength="490"
                ></el-input>
              </el-col>
            </div>
            <div style="clear: both; line-height: 1.8; width: 50%;padding-top: 10px;color: #fda400;">
              <div class="tips">
                【扬帆出海】已记入总字数，当前 <span>{{ changeTemContent.length +6}}</span> 字，预计发送条数约为
                <span>{{ contentArticle }}</span>
                条。实际发送时，签名、变量长度会影响总字数。
                              <span>
                                 {{templateDetail.smsTem}}
                              </span>
<!--                具体计费条数请-->
<!--                <span-->
<!--              >以模板审核通过后发送测试为基准</span-->
<!--              >-->
              </div>
            </div>
            <div style="width: 50%">
            </div>
          </el-form-item>
          <div v-if="templateDetail.tplVar.length">
            <el-tooltip placement="top" style="width: 1000px">
              <div slot="content">
                <el-image style="width: 1000px" src="https://cdn-img.yfchuhai.com/www.yfchuhai.com/www.yfchuhai.com/static/pc/img/common/20250708-171128.jpg"></el-image>
              </div>
             <span style="color: red;margin-left: 120px;padding-bottom: 20px;display: inline-block">
               固定模版请填写变量
                <i class="el-icon-question refesh" ></i>
             </span>
            </el-tooltip>
            <el-form-item  required :label="item" v-for="item in templateDetail.tplVar">
              <el-col :span="8">
                <el-input v-if="item"  placeholder="请输入变量内容" v-model="templateVar[item]"></el-input>
              </el-col>
            </el-form-item>
          </div>
          <el-form-item label="导入手机号码">
            <el-col style="margin-bottom: 20px" >
              <el-button @click="Import">
                {{ impEX }}
              </el-button>
              <a  style="margin-left: 20px" v-if="phoneDetail.url" :href="phoneDetail.url">已导入的{{phoneDetail.num}}个有效手机号码</a>
              <a  style="margin-left: 20px" href="https://admin.yfchuhai.com/xlsx/smsTemplate.xlsx">点击下载导入手机号模版</a>
            </el-col>
          </el-form-item>
          <el-form-item label="是否为测试任务">
            <el-radio v-model="form.testing" :label="true">测试任务</el-radio>
            <el-radio v-model="form.testing" :label="false">正式任务</el-radio>
          </el-form-item>
          <el-form-item label="输入手机号码">
            <template #label>
              <div>
                输入手机号码
                <el-tooltip  class="item" effect="dark" content="因发送需求正式发送短信 默认携带三个号码" placement="top">
                  <i class="el-icon-question refesh" ></i>
                </el-tooltip>
              </div>
            </template>
            <el-row>
              <el-col :span="24" style="display: flex"  class="promiseInput">
                <el-input :maxlength="11" placeholder="请输入11位的手机号码" v-model="inputValue" style="width: 530px">
                </el-input>
                <el-button :disabled="inputValue.length<11"  class="input-content"  @click="handleClickBtn" type="primary"
                           style="margin-left: 20px">
                  <span class="maxLength">
                  {{inputValue.length}}/11
                </span>
                  添加</el-button>
              </el-col>
              <el-col>

                <el-tag v-for="(item,index) in phoneList" :key="item" :closable="form.testing?true:index>2?true:false"
                        :disable-transitions="false" @close="handleCloseTag(item)"
                        style="margin:20px 20px 0px 0px">
                  {{ item }}
                </el-tag>
              </el-col>

            </el-row>

          </el-form-item>

          <el-form-item label="审批人">
            <el-col :span="8">
              <el-select
                  multiple
                  v-model="form.approvalUser"
                  size="medium"
                  placeholder="请选择审批人"
                  style="width:300px;margin-right: 5px;"
              >
                <el-option  v-for="item in approvalUserList" :key="item.value" :label="item.name" :value="item.value"></el-option>
              </el-select>
            </el-col>

          </el-form-item>
          <el-form-item label="收件人列表标签">
            <el-col :span="8">
              <fuzzy-selection
                  tipName="收件人列表标签"
                  :type="13"
                  width="100%"
                  :value.sync="form.tagId"
              ></fuzzy-selection>
            </el-col>
          </el-form-item>
          <el-form-item label="发送时间">
            <el-radio v-model="form.sendTimeType" :label="0">立即发送</el-radio>
            <el-radio v-model="form.sendTimeType" :label="1">定时发送</el-radio>
            <div v-if="form.sendTimeType == 1">
              <div-picker v-model="form.sendTime"> </div-picker>
            </div>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" size="small" @click="add">{{ "提交审核" }}</el-button>
            <!-- <el-button size="small" @click="preview">{{ "预览" }}</el-button> -->
          </el-form-item>
        </el-form>
      <div class="text-message-preview">
<div class="preview">
【扬帆出海】{{changeTemContent}}
</div>
      </div>
      </div>
    </el-card>
    <el-dialog :visible.sync="show" width="750px"> </el-dialog>
  </div>
</template>

<script>
import fuzzySelection from "@/components/fuzzySelection";
export default {
  components: {
    fuzzySelection,
  },
  data() {
    return {

      form: {
        testing:true,
        title: "",
        remark: "",
        sign:"【扬帆出海】",
        sendTime:"",
        sendTimeType:0,
        templateId:'',
        approvalUser:[],
        templateVar: ''
      },
      templateDetailShow:false,
      inputValue: '',
      phoneList:[

      ],
      channelList:[],
      templateDetail:{
        content:'',
        tplVar:''
      },
      phoneDetail:{},
      impEX:'导入手机号码Excel',
      importExcel:false,
      approvalUserList:[],
      templateVar:{

      }
    };
  },
  watch: {
    'form.testing': {
      handler: function () {
        if (this.form.testing){
          this.phoneList=[]
        }else {
          this.phoneList=[
            '15318726247', //起沙
            '13960797109', //林君
            '15080329619' //王璐
          ]

        }
        console.log(this.phoneList)
      },
      // 开启深度监听：只要obj中的任何一个属性发生改变，都会触发相应的代码
      deep: true
    }
  },
  created() {
    // this.id = this.$route.query.id;
    // this.getForm();
    this.getChannelList()
    this.getApprovalUserList()
  },

  methods: {
    getTemplateName(e){
      console.log(e)
      this.form.title = e
    },
    Import(val) {
      var that = this;
      if (this.impEX == "导入手机号码Excel") {
        const input = document.createElement("input");
        input.type = "file";
        input.accept = ".xlsx";

        input.click();
        input.onchange = function() {
          // console.log(this.files[0])
          var file = this.files[0];
          var formData = new FormData();
          formData.append("file", file);
          var url;
          if (val == "new") {
            url = "/admin/UserGuest/importExcelNew";
            that.importExcel = true;
          } else {
            url = "/admin/Sms/getImportPhoneNum";
          }
          that.$http.post(url, formData).then(({ data: res }) => {
            if (res.errorCode == 200) {
              that.phoneDetail=res.data
              that.$message.success(res.message);
            } else {
              that.$message.error(res.message);
            }
            if (val != "new") {
              that.impEX = "导入手机号码Excel";
            } else {
              that.importExcel = false;
            }
          });

          if (val != "new") {
            that.impEX = "导入中";
          }
        };
      }
    },
    /**
     * 根据短信模版id获取模版详情
     * @returns {Promise<void>}
     */
 async getTemplateById(){
    const {data}=await  this.$http.get('/admin/Sms/getTemplateById?id='+this.form.templateId)
      if (data.data.tplVar.length > 0) {
        data.data.tplVar.forEach(item => {
          this.$set(this.templateVar, item, '');
        })
      }
      console.log(this.templateVar)
      this.templateDetail=data.data
      this.form.title = data.data.title;
      this.templateDetail.smsTem= data.data.channel == 'XuanWu'?'': `
                当前短信服务商为:${
          data.data.channelName
      }  剩余短信条数:${data.data.smsNum}
      预计可发送:${ Math.ceil(data.data.smsNum/this.contentArticle)}人
`
},
    /**
     * 点击添加手机号码
     */
    handleClickBtn() {
      if(this.inputValue.length<11){
        this.$message("请输入11位的手机号码")
      }else {
        this.phoneList.push(this.inputValue)
        this.inputValue = ''
        console.log(this.phoneList)
      }

    },
    /**
     * 手机号码关闭
     * @returns {Promise<void>}
     */
    handleCloseTag(tag) {

      this.phoneList.splice(this.phoneList.indexOf(tag), 1)
    },
    goBack() {
      this.$router.go(-1);
    },
    async getForm() {
      if (!this.id) return;
      let { data: res } = await this.$http.get("/admin/Sms/getTemplateById", { params: { id: this.id } });
      if (res.errorCode == 200) {
        this.form = res.data;
      }
    },
    async getChannelList(){
      let { data: res } = await this.$http.get("/admin/Sms/getChannelList");
      this.channelList = res.data;
    },
    async getApprovalUserList(){
      let { data: res } = await this.$http.get("/admin/Sms/getApprovalUserList");
      this.approvalUserList = res.data;
    },
    pleaseSelect() {},
    showEdit(row) {
      this.form.topId = row.id;
      this.form.topTitle = row.title;
    },
    async add() {
      var url = "/admin/Sms/createTask";
      const form = {
        ...this.form,
        approvalUser:this.form.approvalUser.join(','),
        templateVar:JSON.stringify(this.templateVar),
      }
      let { data: res } = await this.$http.post(url, {fileUrl:this.phoneDetail.url,phone:this.phoneList.join(','),...form});
      if (res.errorCode == 200) {
        this.$message.success(res.message);
        this.$router.go(-1);
      }
    },
    preview() {
      this.show = true;
    },
    select() {
      this.$refs.pop.init(this.form.topType, this.form.topId);
    },
  },
  computed: {
    contentArticle() {
      var length = this.changeTemContent.length+6;
      return Math.ceil(length / 67);
    },
    changeTemContent(){
      let content=this.templateDetail.content
      if(this.templateDetail.tplVar.length){
        this.templateDetail.tplVar.forEach(item=>{
          content=content.replace('#'+item+'#',this.templateVar[item])
        })
      }else {
        content = this.templateDetail.content
      }
      return content
    }
  },
};
</script>

<style lang="less" scoped>
.for {
  transform: scale(0.5);
  transform-origin: 0 0;
}
.tips {
  color: gray;
  span {
    color: red;
  }
}
.text-message-preview{
  width: 387px;
  height: 711px;
  margin-right: 50px;
  position: relative;
  background: url("https://cdn-img.yfchuhai.com/www.yfchuhai.com/static/pc/img/backstage/text-message-preview.png") no-repeat;
.preview{
  max-width: 220px;
  background: #f5f5f5;
  border-radius: 4px;
  position: absolute;
  top: 156px;
  left: 72px;
  padding: 13px;
}
}
.input-content{
  position: relative;
}
.maxLength{
  position: absolute;
  top: 12px;
  left: -67px;
  color: #DCDFE6;
}

</style>